import React, { memo } from 'react'
import { RenderAorB, RenderIf } from '../../utils/fns'
import ReactHtmlParser from 'react-html-parser'

const AlertRoot = memo((props) => {
  const { level, icon, title, description } = props

  return RenderIf(
    description,
    <div className={`notice${level ? ' -' + level : ''}`} {...props}>
      {RenderAorB(
        icon,
        <span className="material-icons">{icon}</span>,
        <span className="material-icons">info</span>,
      )}

      <div className="notice__text">
        {RenderIf(title, <div className="notice__header">{title}</div>)}
        <div className="notice__body">{ReactHtmlParser(description)}</div>
      </div>
    </div>,
  )
})

AlertRoot.displayName = 'Alert'

AlertRoot.defaultProps = {
  level: 'info', // Default level is set to 'info'
  icon: 'info',
  title: '', // Default title is an empty string
  description: '',
}

const Alert = {
  Info: (props) => <AlertRoot level="info" icon="info" {...props} />,
  Error: (props) => <AlertRoot level="error" icon="error" {...props} />,
  Warning: (props) => <AlertRoot level="warning" icon="warning" {...props} />,
  NetworkError: () => (
    <AlertRoot
      level="error"
      icon="error"
      title="Network Error"
      description="The network connection is currently unavailable to generate results. Please try your calculations again at a later time."
    />
  ),
  NoResultWarning: () => (
    <AlertRoot
      level="warning -noResults"
      icon="warning"
      title="No Output Results"
      description="There are no results based upon the input parameters. Try editing your input criteria, or use the reset button to load the initial conditions."
    />
  ),
  ValidationError: (props) => (
    <AlertRoot level="error" icon="error" title="Validation" {...props} />
  ),
}

export default Object.assign(AlertRoot, Alert)
